export default __webpack_public_path__ + "static/6765-6fce243e5ff2d2c1a615715497741aaf.jpg";